import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { required } from '@utils/validators';
import { guestSelectors } from '@store/guest/selectors';
import { roomRateBookingFormConfig } from '../../shared';
import { GuestDetailsStep } from './GuestDetailsStep';

const validate = (values: any) => {
  const errors: any = {};

  if (!values.guests || !values.guests.length) {
    errors.guests = {
      _error: required(),
    };
  } else {
    const guestArrayErrors: any[] = [];
    values.guests.forEach((guest, guestIndex) => {
      const singleMemberErrors: any = {};
      if (guestIndex === 0) {
        singleMemberErrors.title = required(guest.title);
        singleMemberErrors.firstName = required(guest.firstName);
        singleMemberErrors.lastName = required(guest.lastName);
      }
      guestArrayErrors[guestIndex] = singleMemberErrors;
    });
    if (guestArrayErrors.length) {
      errors.guests = guestArrayErrors;
    }
  }

  return errors;
};

const selector = formValueSelector(roomRateBookingFormConfig.form);

const mapStateToProps = (state) => ({
  selectedGuests: selector(state, 'guests'),
  loggedGuest: guestSelectors.getGuest(state),
  note: selector(state, 'note'),
});

const GuestDetailsStepForm = reduxForm({
  ...roomRateBookingFormConfig,
  enableReinitialize: true,
  validate,
})(GuestDetailsStep as any);

export const GuestDetailsStepContainer: any = connect(mapStateToProps)(GuestDetailsStepForm);
